import { render, staticRenderFns } from "./monitor.vue?vue&type=template&id=2422dc15&"
import script from "./monitor.vue?vue&type=script&lang=js&"
export * from "./monitor.vue?vue&type=script&lang=js&"
import style0 from "./monitor.vue?vue&type=style&index=0&id=2422dc15&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports